// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2TfAw","footer":"ModalError_footer__1vvLW"};